import React, { useMemo } from 'react';
import type { Conversation, InboxResponse } from 'types/interfaces/message';
import { sectionRows } from '../threadRowModel';
import ThreadRow from './ThreadRow';

interface Props {
  rows: Conversation[];
  groupCounts?: InboxResponse['groupCounts'];
  selectedIds: ReadonlySet<string>;
  activeId?: string | null;
  showCheckboxes: boolean;
  onOpen: (conversationId: string) => void;
  onToggleSelect: (conversationId: string, e: React.MouseEvent<HTMLInputElement>) => void;
  onContextMenu: (conversationId: string, e: React.MouseEvent) => void;
  onArchive: (conversationId: string, e: React.MouseEvent) => void;
}

/**
 * Grouped thread rows: Needs you, In progress, Earlier (Decision 5), with a
 * header and count wherever the server-ordered rows change group.
 */
const ThreadList: React.FC<Props> = ({
  rows,
  groupCounts,
  selectedIds,
  activeId,
  showCheckboxes,
  onOpen,
  onToggleSelect,
  onContextMenu,
  onArchive,
}) => {
  const sections = useMemo(() => sectionRows(rows, groupCounts), [rows, groupCounts]);

  return (
    <div className="thread-list" role="list">
      {sections.map((section, index) => (
        <div key={`${section.group}-${index}`} className="thread-section" data-group={section.group}>
          <div className="thread-group-header" role="presentation">
            <span className="thread-group-label">{section.label}</span>
            <span className="thread-group-count">{section.count}</span>
          </div>
          {section.rows.map((row) => (
            <ThreadRow
              key={row.conversationId}
              row={row}
              selected={selectedIds.has(row.conversationId)}
              active={row.conversationId === activeId}
              showCheckbox={showCheckboxes}
              onOpen={onOpen}
              onToggleSelect={onToggleSelect}
              onContextMenu={onContextMenu}
              onArchive={onArchive}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default ThreadList;
